var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVictoryNative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8528 13.2494H20.4374L17.7349 23.1227L18.9351 27.4994L22.8528 13.2494Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92432 6.26868H8.32355L14.1363 27.4997C13.447 27.4997 12.7769 27.2732 12.2289 26.8551C11.681 26.437 11.2856 25.8505 11.1036 25.1857L5.92432 6.26868Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1709 4.25159C10.8601 4.25159 11.5303 4.47807 12.0782 4.89616C12.6262 5.31425 13.0216 5.90081 13.2036 6.56558L18.9352 27.4996H16.536L10.1709 4.25159Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77162 4.25159H10.1706L16.5359 27.4996H14.1367L8.32365 6.26783H5.64056C5.04023 6.26783 4.45655 6.07046 3.97941 5.70613C3.50227 5.3418 3.15813 4.83072 3 4.25159H7.77162Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9106 16.6757H24.2915L26.6884 7.98223L28.0733 9.9671C29.0548 9.28057 29.2946 7.9288 28.6093 6.94649L26.5534 4L23.1929 5.58152C22.1035 6.09429 21.6359 7.39323 22.1486 8.48272L22.1497 8.48501L24.4599 7.39773L21.9106 16.6757Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVictoryNative);
export default __webpack_public_path__ + "static/media/victory_native.ff9b35a94ef6268477b78bc446bfeb2e.svg";
export { ForwardRef as ReactComponent };